<div class="init-screen">
  <div class="init-content">
    <img src="logo-login.svg" alt="aInstitute" class="init-logo" />
    <div class="spinner-ring">
      <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <circle class="spinner-track" cx="25" cy="25" r="20" fill="none" stroke-width="3"/>
        <circle class="spinner-arc"   cx="25" cy="25" r="20" fill="none" stroke-width="3"/>
      </svg>
    </div>
    <p class="init-label">Initializing Application…</p>
  </div>
</div>
